<template>
  <div class="studentView flex">
    <!-- 学生列表部分开始 -->
    <div class="studentList-content">
      <!-- 班级选择器 -->
      <div class="classSelector flex align justify">
        <div class="selector-txt">班级</div>
        <el-cascader v-model="classValue" @change="classHandleChange" :options="classOptions"></el-cascader>
      </div>
      <!-- 学生列表 -->
      <div class="studentList-box">
        <div @click="selectStudents(item.id)" v-for="(item, index) in studentList" :key="index"
          :class="currentStudentId == item.id ? 'selectStudents' : 'unSelectStudents'">
          <div class="flex align">
            <img class="rankImg" v-if="index == 0" src="@/assets/first.png" />
            <img class="rankImg" v-if="index == 1" src="@/assets/second.png" />
            <img class="rankImg" v-if="index == 2" src="@/assets/third.png" />
            <div class="student-ranking" v-if="index != 0 && index != 1 && index != 2">{{ index + 1 }}</div>
            <img class="head-sculpture" :src="item.icon != '' ? item.icon : require('@/assets/head.png')" />
            <div class="flex column spaceBetween" style="margin-left: 10px">
              <div class="studentTxt">{{ item.name }}</div>
              <div class="studentTxt">{{ item.account }}</div>
            </div>
          </div>
          <div class="flex align">
            <div class="integral-num">{{ item.coursePoints }}</div>
            <div class="integral-txt">积分</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 学生列表部分结束 -->
    <!-- 课次列表部分开始 -->
    <div class="classTimesList">
      <!-- 输入课次搜索框 -->
      <div class="courseSearch-content">
        <div class="courseSearch-box flex align spaceBetween">
          <input v-model="courseName" @keyup.enter="courseSearch(courseName)" class="courseSearch" type="text"
            placeholder="输入课次名称" />
          <img @click="courseSearch(courseName)" class="searchIcon pointer"
            src="../../assets/resourceManagement/searchIcon.png" />
        </div>
      </div>
      <!-- 课次列表标题 -->
      <div class="classTimesList-title-box flex align">
        <div class="classTimesList-block"></div>
        <div class="classTimesList-title">课次列表</div>
      </div>
      <!-- 课次列表 -->
      <div class="classList-box">
        <div @click="singleClass(item)" :class="currentClassesId == item.id ? 'allClasses' : 'classList'"
          v-for="(item, index) in allListClasses" :key="index">
          <div class="flex align">
            <div class="classList-circle"></div>
            <div class="classList-num">课次{{ index + 1 }}</div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
          <div class="flex align">
            <div class="integral-num">{{ item.integral }}</div>
            <div class="integral-txt">积分</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课次列表部分结束 -->
    <!-- 课程数据部分开始 -->
    <div class="data-box">
      <!-- 数据标题 -->
      <div class="classTimesList-title-box flex align">
        <div class="classTimesList-block"></div>
        <div class="classTimesList-title">{{ dataType == "课程" ? this.$store.state.courseDetails.name + "-课程数据" :
          currentClassesName + "-课次数据" }}</div>
      </div>
      <!-- 课程数据 -->
      <div v-show="dataType == '课程'" class="courseData-box flex column">
        <div class="flex spaceBetween">
          <div class="echartsPie-box">
            <echartsPie :preData="preData[0]"></echartsPie>
            <div class="flex">
              <div class="echartsPie-key">观看数量</div>
              <div class="echartsPie-value">{{ dataEcharts[0].watched }}/{{ dataEcharts[0].notWatched }}</div>
            </div>
            <div class="flex" style="margin-top: 10px">
              <div class="echartsPie-key">观看时长</div>
              <div class="echartsPie-value">{{ dataEcharts[0].minuteSecond }}</div>
            </div>
          </div>
          <div class="echartsPie-box" style="margin-left: 20px">
            <echartsPie :preData="preData[1]"></echartsPie>
            <div class="flex">
              <div class="echartsPie-key">习题完成度</div>
              <div class="echartsPie-value">{{ dataEcharts[1].completionDegree }}/{{ dataEcharts[1].completionTotal }}
              </div>
            </div>
            <div class="flex" style="margin-top: 16px">
              <div class="echartsPie-key">习题正确度</div>
              <div class="echartsPie-value">{{ dataEcharts[1].accuracy }}/{{ dataEcharts[1].completionTotal }}</div>
            </div>
          </div>
        </div>
        <div class="echartsPie-box" style="margin-top: 100px">
          <echartsPie :preData="preData[2]"></echartsPie>
          <div class="flex">
            <div class="echartsPie-key">作业完成度</div>
            <div class="echartsPie-value">{{ dataEcharts[2].completionDegree }}/{{ dataEcharts[2].completionTotal }}
            </div>
          </div>
          <div class="flex" style="margin-top: 10px">
            <div class="echartsPie-key">作业正确度</div>
            <div class="echartsPie-value">{{ dataEcharts[2].accuracy }}/{{ dataEcharts[2].completionTotal }}</div>
          </div>
        </div>
      </div>
      <!-- 课次数据 -->
      <div v-show="dataType == '课次'" class="classNumberData-box flex column">
        <div class="flex spaceBetween" style="padding-bottom: 5px; box-sizing: border-box">
          <div class="echarts-box">
            <myChart :preData="preData[0]"></myChart>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">观看数量</div>
              <div class="echartsPie-value">{{ dataEcharts[0].watched }}/{{ dataEcharts[0].notWatched }}</div>
            </div>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">观看时长</div>
              <div class="echartsPie-value">{{ dataEcharts[0].minuteSecond }}</div>
            </div>
          </div>
          <div class="echarts-box">
            <myChart :preData="preData[1]"></myChart>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">习题完成度</div>
              <div class="echartsPie-value">{{ dataEcharts[1].completionDegree }}/{{ dataEcharts[1].completionTotal }}
              </div>
            </div>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">习题正确度</div>
              <div class="echartsPie-value">{{ dataEcharts[1].accuracy }}/{{ dataEcharts[1].completionTotal }}</div>
            </div>
          </div>
          <div class="echarts-box">
            <myChart :preData="preData[2]"></myChart>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">作业完成度</div>
              <div class="echartsPie-value">{{ dataEcharts[2].completionDegree }}/{{ dataEcharts[2].completionTotal }}
              </div>
            </div>
            <div class="flex justify" style="margin-top: 10px">
              <div class="echartsPie-key">作业正确度</div>
              <div class="echartsPie-value">{{ dataEcharts[2].accuracy }}/{{ dataEcharts[2].completionTotal }}</div>
            </div>
          </div>
        </div>
        <!-- 教学实施部分开始 -->
        <div class="tableStyle flex column align">
          <div class="tableWidth">
            <div class="resourceList-h1Box flex align">
              <div class="resourceList-colorBlock"></div>
              <div class="resourceList-h1">教学实施</div>
            </div>
            <!-- 课前准备部分开始 -->
            <div style="margin-top: 2px">
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课前准备</div>
              </div>
              <el-table :data="beforeClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <img @click="viewResources(scope)" class="btnView pointer"
                      src="../../assets/studentStatisticsIcon/iocnView.png" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 课前准备部分结束 -->
            <!-- 课堂教学部分开始 -->
            <div>
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课堂教学</div>
              </div>
              <el-table :data="middleClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <img @click="viewResources(scope)" class="btnView pointer"
                      src="../../assets/studentStatisticsIcon/iocnView.png" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 课堂教学部分结束 -->
            <!-- 课后巩固部分开始 -->
            <div>
              <div class="resourceList-h2Box flex align">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课后巩固</div>
              </div>
              <el-table :data="afterClassList" :show-header="false" :cell-style="tableRowClassName"
                :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score1"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    <img @click="viewResources(scope)" class="btnView pointer"
                      src="../../assets/studentStatisticsIcon/iocnView.png" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 课后巩固部分结束 -->
          </div>
        </div>
        <!-- 教学实施部分结束 -->
      </div>
    </div>
    <!-- 课程数据部分结束 -->
    <!-- 资源查看弹窗部分开始 -->
    <div v-show="showPopupResourceView" class="popup-resourceView flex align justify">
      <div class="resourceView-content">
        <img @click="(showPopupResourceView = false), (currentTestQuestionIdx = 0)" class="btnClose pointer"
          src="../../assets/btnClose.png" />
        <div class="popup-title flex justify">{{ dataResourceView.typesOf }}详情</div>
        <!-- 资源 -->
        <div v-if="dataResourceView.typesOf == '资源'">
          <div class="resourcesDetails-frame flex align justify">
            <el-image v-if="dataResourceView.types == '图片资源'" class="resourcesDetails-img" fit="cover"
              :src="dataResourceView.content[0]" :preview-src-list="dataResourceView.content"> </el-image>
            <video v-else-if="dataResourceView.types == '视频资源'" class="resourcesDetails-frame1" controls
              :src="dataResourceView.content[0]"></video>
            <img v-else @click="viewRes" class="resourcesDetails-typeImg pointer"
              src="@/assets/documentResourcesIcon.png" />
          </div>
          <div class="flex">
            <div class="dataResourceView-key">资源名称：</div>
            <div class="dataResourceView-value">{{ dataResourceView.name }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">资源类型：</div>
            <div class="dataResourceView-value">{{ dataResourceView.types }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">资源分值：</div>
            <div class="dataResourceView-value">{{ dataResourceView.score1 }}</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">得分设置：</div>
            <div class="dataResourceView-value">观看{{ dataResourceView.percent }}%以上即可得分</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">学生得分：</div>
            <div class="dataResourceView-value">{{ dataResourceView.studentScore }}分</div>
          </div>
          <div class="flex">
            <div class="dataResourceView-key">查看次数：</div>
            <div class="dataResourceView-value">{{ dataResourceView.studentViewNum }}次</div>
          </div>
        </div>
        <!-- 习题 -->
        <div v-if="dataResourceView.typesOf == '习题'">
          <div class="flex spaceBetween">
            <div class="flex align">
              <div class="questionType-block"></div>
              <div class="questionType">{{ dataResourceView.types }}</div>
            </div>
            <div class="question-score">{{ dataResourceView.studentScore }}/{{ dataResourceView.score }}分</div>
          </div>
          <div class="question-stem">{{ dataResourceView.name }}</div>
          <div v-for="(item, index) in dataResourceView.options" :key="index">
            <div v-if="dataResourceView.types != '简答题'"
              :class="dataResourceView.studentAnswer.includes(index) ? 'question-option flex align' : 'question-option1 flex align'">
              {{ optionOrder[index] }}.{{ item }}
              <img v-if="dataResourceView.studentAnswer.includes(index)" class="iconIsItCorrect"
                :src="require(`@/assets/${dataResourceView.studentScore == dataResourceView.score ? 'correct' : 'error'}Icon.png`)" />
            </div>
          </div>
          <div v-if="dataResourceView.types == '简答题'" class="answers-box">{{ dataResourceView.studentAnswer }}</div>
          <div v-if="dataResourceView.types != '简答题'" class="question-txt">答案：{{ dataResourceView.translatedAnswer }}
          </div>
          <div v-if="dataResourceView.types != '简答题'" class="question-txt">学生答案：{{ dataResourceView.studentEnglishAnswer
            }}
          </div>
          <div class="question-txt">解析：{{ dataResourceView.comment }}</div>
        </div>
        <!-- 作业 -->
        <div v-if="dataResourceView.typesOf == '作业'">
          <div class="exam-detailsContent flex column spaceBetween">
            <div class="flex spaceBetween">
              <div class="flex">
                <div class="exam-key">作业名称：</div>
                <div class="exam-value">{{ dataResourceView.name }}</div>
              </div>
              <div class="flex" style="width: 120px">
                <div class="exam-key">作业完成度：</div>
                <div class="exam-value">{{ dataResourceView.examCompletionDegree }}/{{ dataResourceView.num_item }}
                </div>
              </div>
            </div>
            <div class="flex spaceBetween">
              <div class="flex">
                <div class="exam-key">作业得分：</div>
                <div class="exam-value">{{ dataResourceView.examScore }}/{{ dataResourceView.score1 }}</div>
              </div>
              <div class="flex" style="width: 120px">
                <div class="exam-key">作业正确率：</div>
                <div class="exam-value">{{ dataResourceView.examCorrectDegree }}/{{ dataResourceView.num_item }}</div>
              </div>
            </div>
          </div>
          <div class="examitem-box">
            <div class="examitem-type flex spaceBetween">
              <div class="flex align">
                <div class="questionType-block"></div>
                <div class="questionType">{{ dataResourceView.exam_items[currentTestQuestionIdx].exam_item.types }}
                </div>
              </div>
              <div class="question-score">{{ dataResourceView.exam_items[currentTestQuestionIdx].exam_item.getScore
                }}/{{
          dataResourceView.exam_items[currentTestQuestionIdx].exam_item.score }}分</div>
            </div>
            <div class="question-stem">{{ dataResourceView.exam_items[currentTestQuestionIdx].exam_item.content }}</div>
            <div v-for="(item, index) in dataResourceView.exam_items[currentTestQuestionIdx].exam_item.options"
              :key="index">
              <div v-if="dataResourceView.types != '简答题'"
                :class="dataResourceView.exam_items[currentTestQuestionIdx].exam_item.studentAnswer.includes(index) ? 'question-option flex align' : 'question-option1 flex align'">
                {{ optionOrder[index] }}.{{ item }}
                <img v-if="dataResourceView.exam_items[currentTestQuestionIdx].exam_item.studentAnswer.includes(index)"
                  class="iconIsItCorrect"
                  :src="require(`@/assets/${dataResourceView.exam_items[currentTestQuestionIdx].exam_item.getScore == dataResourceView.exam_items[currentTestQuestionIdx].exam_item.score ? 'correct' : 'error'}Icon.png`)" />
              </div>
            </div>
            <div v-if="dataResourceView.exam_items[currentTestQuestionIdx].exam_item.types == '简答题'"
              class="answers-box">{{
          dataResourceView.exam_items[currentTestQuestionIdx].exam_item.studentAnswer }}</div>
            <div v-if="dataResourceView.exam_items[currentTestQuestionIdx].exam_item.types != '简答题'"
              class="question-txt">
              答案：{{ dataResourceView.exam_items[currentTestQuestionIdx].exam_item.translatedAnswer }}</div>
            <div v-if="dataResourceView.exam_items[currentTestQuestionIdx].exam_item.types != '简答题'"
              class="question-txt">
              学生答案：{{ dataResourceView.exam_items[currentTestQuestionIdx].exam_item.studentEnglishAnswer }}</div>
            <div class="question-txt">解析：{{ dataResourceView.exam_items[currentTestQuestionIdx].exam_item.comment }}
            </div>
          </div>
          <div class="flex spaceBetween">
            <div @click="btnQuestion('previous')" class="btnPreviousQuestion flex align justify pointer">上一题</div>
            <div @click="btnQuestion('next')" class="btnNextQuestion flex align justify pointer">下一题</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资源查看弹窗部分结束 -->
  </div>
</template>

<script>
// 接口
import { courseLearningRecords, classCascade, obtainTeacherTeachingClass } from "@/api";
// 组件
import echartsPie from "@/components/echarts_pie";
// 组件
import myChart from "@/components/echarts_pie/echats.vue";
import { Toast } from "vant";
export default {
  data() {
    return {
      dataView: [
        // 切换功能列表
        {
          imgSrc: require("../../assets/studentStatisticsIcon/studentView.png"),
        },
        {
          imgSrc: require("../../assets/studentStatisticsIcon/unClassNumView.png"),
        },
        {
          imgSrc: require("../../assets/studentStatisticsIcon/unResourceView.png"),
        },
      ],
      studentList: [], // 学生列表
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      currentStudentId: 0, // 当前学生id
      classId: 0,
      allListClasses: [], // 课次列表
      allListClasses1: [], // 课次列表原始数据
      currentClassesId: 0, // 当前课次id
      currentClassesName: 0, // 当前课次名称
      courseName: "", // 课次搜索的课次名称
      dataType: "课程", // 课程课次切换
      preData: [
        {
          title: "资源详情",
          show: false,
          typeList: [
            { value: 0, name: "已得分数" },
            { value: 0, name: "未得分数" },
          ],
          countLength: "",
        },
        {
          title: "习题详情",
          show: false,
          typeList: [
            { value: 0, name: "已得分数" },
            { value: 0, name: "未得分数" },
          ],
          countLength: "",
        },
        {
          title: "作业详情",
          show: false,
          typeList: [
            { value: 0, name: "已得分数" },
            { value: 0, name: "未得分数" },
          ],
          countLength: "",
        },
      ],
      // echarts详情数据
      dataEcharts: [
        { watched: 0, notWatched: 0, minuteSecond: "00分00秒" },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
      ],
      resourceList: [], // 资源列表
      beforeClassList: [], // 课前列表
      middleClassList: [], // 课中列表
      afterClassList: [], // 课后列表
      dataResourceView: {}, // 资源查看数据
      showPopupResourceView: false, // 是否展示资源查看弹窗
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      currentTestQuestionIdx: 0, // 当前试题下标
    };
  },
  components: { echartsPie, myChart },
  created() {
    // 调用获取老师授课班级列表接口
    let params = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params).then((res) => {
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.classId = res.data.datas[0].id;
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 第一层按value从大到小排列
      this.classOptions.sort((a, b) => b.value.split("级")[0] - a.value.split("级")[0]);
      // 第二层的children按value从小到大排列
      this.classOptions.forEach(item => {
        if (item.children && Array.isArray(item.children)) {
          item.children.sort((a, b) => a.name.split("班")[0] - b.name.split("班")[0]);
        }
      });
      // 调用获取数据方法
      this.publicGettingDataFunc();
    });
  },
  methods: {
    // 转换成00分00秒格式
    funcTimeConversion(num) {
      let minutes = Math.floor(num / 60);
      let seconds = num % 60;
      let formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      let formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
      let result = formattedMinutes + "分" + formattedSeconds + "秒";
      return result;
    },
    // 升序、降序排序
    compare(property, desc) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (desc == true) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
    // 判断字符串最后一个字符是否为,有则删掉
    processString(str) {
      // 获取字符串最后一个字符的索引
      const lastCharIndex = str.lastIndexOf(",");
      // 如果最后一个字符是逗号，则删除它
      if (lastCharIndex === str.length - 1) {
        return str.slice(0, lastCharIndex);
      }
      // 如果最后一个字符不是逗号，则返回原字符串
      return str;
    },
    // 获取数据方法
    publicGettingDataFunc() {
      this.dataEcharts = [
        { watched: 0, notWatched: 0, minuteSecond: "00分00秒" },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
        { completionDegree: 0, completionTotal: 0, accuracy: 0 },
      ];
      this.preData[0].typeList[0].value = 0;
      this.preData[1].typeList[0].value = 0;
      this.preData[2].typeList[0].value = 0;
      let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
      courseLearningRecords(params).then((res) => {
        // 获取学生表格数据
        this.studentList = res.data.ext.users.map((item) => {
          item.coursePoints = 0;
          res.data.ext.lesson_user.map(({ score, user_account }) => {
            if (item.account == user_account) {
              // 计算单个课次课程积分
              item.coursePoints += score;
              // 获取当前课程课次的数据
              this.allListClasses = this.$store.state.classListRecord.map(({ name, id }) => {
                return { name: name, id: id, integral: 0 };
              });
            }
          });
          return { id: item.id, name: item.name, icon: item.icon, account: item.account, coursePoints: item.coursePoints };
        });
        this.studentList.sort(this.compare("coursePoints", false)); // 排名排序
        if (this.currentStudentId == 0) {
          this.currentStudentId = this.studentList[0]?.id; // 获取学生id
        }
        // 计算课程数据echarts图表数据
        this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "分}";
        this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "分}";
        this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "分}";
        let assetsScore = 0; // 资源总分
        let examitemScore = 0; // 习题总分
        let examScore = 0; // 作业总分
        let completeScore = {}; // 作业完成得分
        for (let i in res.data.datas) {
          let publicRes = res.data.datas[i];
          if (this.dataType == "课程" ? publicRes.types == "assets" : publicRes.types == "assets" && publicRes.lesson_item_id == this.currentClassesId) {
            assetsScore += publicRes.assets.score;
            this.dataEcharts[0].notWatched++;
          } else if (this.dataType == "课程" ? publicRes.types == "examitem" : publicRes.types == "examitem" && publicRes.lesson_item_id == this.currentClassesId) {
            examitemScore += publicRes.exam_item.score;
            this.dataEcharts[1].completionTotal++;
          } else if (this.dataType == "课程" ? publicRes.types == "exam" : publicRes.types == "exam" && publicRes.lesson_item_id == this.currentClassesId) {
            examScore += publicRes.exam.score;
            this.dataEcharts[2].completionTotal++;
            completeScore[publicRes.id] = {};
            completeScore[publicRes.id].score = publicRes.exam.score; // 获取作业原始分数
            completeScore[publicRes.id].getScore = 0; // 获取作业原始分数
          }
        }
        // 计算当前课程课次的数据
        this.allListClasses = this.$store.state.classListRecord.map(({ name, id }) => {
          return { name: name, id: id, integral: 0 };
        });
        this.allListClasses1 = this.allListClasses;
        let completeArr = []; // 作业完成度
        let durationTime = 0; // 资源观看总时长
        for (let i in res.data.ext.lesson_user) {
          let publicRes = res.data.ext.lesson_user[i];
          for (let j in this.allListClasses) {
            if (this.allListClasses[j].id == publicRes.lesson_item_id) {
              if (this.currentStudentId == publicRes.user_id) {
                // 计算学生课次积分
                this.allListClasses[j].integral += publicRes.score;
                // console.log(this.allListClasses[j].integral);
                if (this.dataType == "课程" ? publicRes.link_type == "assets" : publicRes.link_type == "assets" && publicRes.lesson_item_id == this.currentClassesId) {
                  this.preData[0].typeList[0].value += publicRes.score;
                  this.dataEcharts[0].watched++; // 计算资源已观看
                  durationTime += publicRes.duration; // 计算资源观看时长
                  this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.preData[0].typeList[0].value + "分}";
                } else if (this.dataType == "课程" ? publicRes.link_type == "examitem" : publicRes.link_type == "examitem" && publicRes.lesson_item_id == this.currentClassesId) {
                  // if (publicRes.link_resource_id == '28190') {
                  // console.log(publicRes);
                  // }
                  this.preData[1].typeList[0].value += publicRes.score;
                  this.dataEcharts[1].completionDegree++; // 计算试题已观看
                  if (publicRes.score == publicRes.score_full) {
                    this.dataEcharts[1].accuracy++; // 计算习题完成
                  }
                  this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.preData[1].typeList[0].value + "分}";
                } else if (this.dataType == "课程" ? publicRes.link_type == "exam" : publicRes.link_type == "exam" && publicRes.lesson_item_id == this.currentClassesId) {
                  this.preData[2].typeList[0].value += publicRes.score;
                  // console.log(publicRes);
                  if (!completeArr.includes(publicRes.link_resource_id)) {
                    completeArr.push(publicRes.link_resource_id);
                  }
                  for (let key in completeScore) {
                    if (key == publicRes.link_resource_id) {
                      completeScore[key].getScore += publicRes.score; // 获取作业获得分数
                    }
                  }
                  this.dataEcharts[2].accuracy = 0;
                  this.dataEcharts[2].completionDegree = completeArr.length; // 计算作业已观看
                  for (let i in completeScore) {
                    if (completeScore[i].score == completeScore[i].getScore) {
                      this.dataEcharts[2].accuracy++; // 计算作业完成
                    }
                  }
                  this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.preData[2].typeList[0].value + "分}";
                }
              }
            }
          }
        }
        // 计算未完成课次积分
        this.preData[0].typeList[1].value = assetsScore - this.preData[0].typeList[0].value;
        this.preData[1].typeList[1].value = examitemScore - this.preData[1].typeList[0].value;
        this.preData[2].typeList[1].value = examScore - this.preData[2].typeList[0].value;
        // 计算资源观看时长
        this.dataEcharts[0].minuteSecond = this.funcTimeConversion(durationTime);
        if (this.dataType == "课次") {
          // 获取课次资源数据
          let courseResources = res.data.datas.filter((item) => item.lesson_item_id == this.currentClassesId);
          // 课次答题记录
          let answerRecordList = res.data.ext.lesson_user.filter(({ lesson_item_id, user_id }) => lesson_item_id == this.currentClassesId && user_id == this.currentStudentId);
          for (let i in courseResources) {
            let publicRes = courseResources[i];
            if (publicRes.types == "assets") {
              publicRes.assets.link_id = publicRes.id;
              publicRes.assets.typesOf = "资源";
              if (publicRes.assets.types == "video") {
                publicRes.assets.types = "视频资源";
              } else if (publicRes.assets.types == "audio") {
                publicRes.assets.types = "音频资源";
              } else if (publicRes.assets.types == "doc") {
                publicRes.assets.types = "文档资源";
              } else if (publicRes.assets.types == "image") {
                publicRes.assets.types = "图片资源";
              } else if (publicRes.assets.types == "web") {
                publicRes.assets.types = "资源链接";
              } else if (publicRes.assets.types == "h5") {
                publicRes.assets.types = "特殊互动";
              }
              publicRes.assets.score1 = publicRes.assets.score + "分"; // 转换分数格式
              publicRes.assets.created = publicRes.assets.created.substring(0, 10);
              this.resourceList.push(publicRes.assets);
            } else if (publicRes.types == "examitem") {
              publicRes.exam_item.link_id = publicRes.id;
              publicRes.exam_item.typesOf = "习题";
              if (publicRes.exam_item.types == "single") {
                publicRes.exam_item.types = "单选题";
              } else if (publicRes.exam_item.types == "multi") {
                publicRes.exam_item.types = "多选题";
              } else if (publicRes.exam_item.types == "truefalse") {
                publicRes.exam_item.types = "判断题";
              } else if (publicRes.exam_item.types == "answer") {
                publicRes.exam_item.types = "简答题";
              }
              publicRes.exam_item.score1 = publicRes.exam_item.score + "分"; // 转换分数格式
              publicRes.exam_item.name = publicRes.exam_item.content.replace(/<[^>]+>/g, ""); // 转换名字格式
              publicRes.exam_item.created = publicRes.exam_item.created.substring(0, 10);
              this.resourceList.push(publicRes.exam_item);
            } else if (publicRes.types == "exam") {
              publicRes.exam.link_id = publicRes.id;
              publicRes.exam.typesOf = "作业";
              if (publicRes.exam.types == "manual") {
                publicRes.exam.types = "作业-手动";
              } else if (publicRes.exam.types == "auto") {
                publicRes.exam.types = "作业-自动";
              }
              publicRes.exam.num_item = publicRes.exam.num_item + "道"; // 转换题数格式
              publicRes.exam.score1 = publicRes.exam.score + "分"; // 转换分数格式
              publicRes.exam.created = publicRes.exam.created.substring(0, 10);
              this.resourceList.push(publicRes.exam);
            }
          }
          for (let i in this.resourceList) {
            let publicRes = this.resourceList[i];
            publicRes.completed = false;
            if (publicRes.typesOf == "资源") {
              for (let j in answerRecordList) {
                if (publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].score > 0) {
                  publicRes.completed = true;
                }
              }
            } else if (publicRes.typesOf == "习题") {
              for (let j in answerRecordList) {
                if (publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].score > 0) {
                  publicRes.completed = true;
                }
              }
            } else if (publicRes.typesOf == "作业") {
              let examScore = 0;
              for (let j in answerRecordList) {
                if (answerRecordList[j].link_type == "exam" && publicRes.link_id == answerRecordList[j].link_resource_id && answerRecordList[j].link_exam_item_id) {
                  examScore += answerRecordList[j].score;
                }
                if (examScore == publicRes.score) {
                  publicRes.completed = true;
                }
              }
            }
            if (publicRes.usage == "front") {
              this.beforeClassList.push(publicRes); // 课前准备数据获取
            } else if (publicRes.usage == "middle") {
              this.middleClassList.push(publicRes); // 课堂教学数据获取
            } else if (publicRes.usage == "back") {
              this.afterClassList.push(publicRes); // 课后巩固数据获取
            }
          }
          //   console.log("课前", this.beforeClassList);
          //   console.log("课中", this.middleClassList);
          //   console.log("课后", this.afterClassList);
        }
      });
    },
    // 班级选择器
    classHandleChange(value) {
      this.classId = value[1];
      this.classValue[1] = value[1]; // 获取班级id
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      // 调用获取数据方法
      this.publicGettingDataFunc();
    },
    // 选择学生
    selectStudents(id) {
      this.dataType = "课程";
      this.currentStudentId = id;
      this.currentClassesId = 0;
      this.publicGettingDataFunc();
    },
    // 课次搜索
    courseSearch(name) {
      this.allListClasses = [];
      for (let i = 0; i < this.allListClasses1.length; i++) {
        if (this.allListClasses1[i].name.indexOf(name) >= 0) {
          this.allListClasses.push(this.allListClasses1[i]);
        }
      }
    },
    // 课次选择
    singleClass(data) {
      this.dataType = "课次";
      this.currentClassesId = data.id;
      this.currentClassesName = data.name;
      this.resourceList = []; // 清空资源数据
      this.beforeClassList = []; // 清空课前准备数据
      this.middleClassList = []; // 清空课堂教学数据
      this.afterClassList = []; // 清空课后巩固数据
      this.publicGettingDataFunc();
    },
    // table行的 className 的回调方法
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      let cellStyle;
      if (row.completed == true) {
        cellStyle = "color:#12A13A";
      } else {
        cellStyle = "";
      }
      return cellStyle;
    },
    // 查看资源
    viewRes() {
      window.open(this.dataResourceView.content[0]);
    },
    // 查看资源
    viewResources(data) {
      this.showPopupResourceView = true;
      if (data.row.typesOf == "资源") {
        data.row.studentScore = 0; // 学生分数
        data.row.studentViewNum = 0; // 学生查看次数
        let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
        courseLearningRecords(params).then((res) => {
          let answerRecord = res.data.ext.lesson_user.filter(({ user_id, link_resource_id }) => user_id == this.currentStudentId && link_resource_id == data.row.link_id);
          if (answerRecord.length != 0) {
            data.row.studentScore = answerRecord[0].score; // 获取学生分数
            data.row.studentViewNum = answerRecord[0].num; // 获取学生查看次数
          }
          // console.log(this.$store.state.classTimesId);
          if (data.row.types == "特殊互动" || data.row.types == "资源链接") {
            if (data.row.content[0].indexOf("?") != -1) {
              data.row.content[0] = data.row.content[0] + "&no=" + this.currentClassesId + "&token=" + this.$store.state.tokenCode;
            } else {
              data.row.content[0] = data.row.content[0] + "?no=" + this.currentClassesId + "&token=" + this.$store.state.tokenCode;
            }
          }
          this.dataResourceView = data.row; // 将整理好的数据渲染到页面
        });
      } else if (data.row.typesOf == "习题") {
        data.row.name = data.row.name.replace(/<[^>]+>/g, ""); // 格式化题目题干
        data.row.comment = data.row.comment.replace(/<[^>]+>/g, ""); // 格式化题目解析
        data.row.studentScore = 0; // 学生分数
        data.row.studentAnswer = ""; // 学生答案
        data.row.translatedAnswer = data.row.answer
          .map((item) => {
            return this.optionOrder[item];
          })
          .join("、"); // 转换后的题目答案
        let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
        courseLearningRecords(params).then((res) => {
          let answerRecord = res.data.ext.lesson_user.filter(({ user_id, link_resource_id }) => user_id == this.currentStudentId && link_resource_id == data.row.link_id);
          if (answerRecord.length != 0) {
            data.row.studentScore = answerRecord[0].score; // 获取学生分数
            if (data.row.types == "简答题") {
              data.row.studentAnswer = answerRecord[0].answer; // 获取学生答案
            } else {
              data.row.studentAnswer = this.processString(answerRecord[0].answer).split(",").map(Number);
              data.row.studentEnglishAnswer = data.row.studentAnswer
                .map((item) => {
                  return this.optionOrder[item];
                })
                .join("、"); // 转换后的学生答题答案
            }
          }
          this.dataResourceView = data.row; // 将整理好的数据渲染到页面
        });
      } else if (data.row.typesOf == "作业") {
        this.dataResourceView = []
        let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classId, types: "" };
        courseLearningRecords(params).then((res) => {
          for (let i in data.row.exam_items) {
            if (data.row.exam_items[i].exam_item.types == "single") {
              data.row.exam_items[i].exam_item.types = "单选题";
            } else if (data.row.exam_items[i].exam_item.types == "multi") {
              data.row.exam_items[i].exam_item.types = "多选题";
            } else if (data.row.exam_items[i].exam_item.types == "truefalse") {
              data.row.exam_items[i].exam_item.types = "判断题";
            } else if (data.row.exam_items[i].exam_item.types == "answer") {
              data.row.exam_items[i].exam_item.types = "简答题";
            }
            data.row.exam_items[i].exam_item.translatedAnswer = data.row.exam_items[i].exam_item.answer
              .map((item) => {
                return this.optionOrder[item];
              })
              .join("、"); // 转换后的题目答案
            let answerRecord = res.data.ext.lesson_user.filter(({ user_id, link_exam_item_id }) => user_id == this.currentStudentId && link_exam_item_id == data.row.exam_items[i].id);
            data.row.exam_items[i].exam_item.studentAnswer = [];
            data.row.exam_items[i].exam_item.getScore = 0;
            data.row.exam_items[i].exam_item.studentEnglishAnswer = "";
            if (answerRecord.length != 0) {
              data.row.exam_items[i].exam_item.getScore = answerRecord[0].score;
              if (data.row.exam_items[i].exam_item.types == "简答题") {
                data.row.exam_items[i].exam_item.studentAnswer = answerRecord[0].answer; // 获取学生答案
              } else {
                data.row.exam_items[i].exam_item.studentAnswer = this.processString(answerRecord[0].answer).split(",").map(Number);
                data.row.exam_items[i].exam_item.studentEnglishAnswer = data.row.exam_items[i].exam_item.studentAnswer
                  .map((item) => {
                    return this.optionOrder[item];
                  })
                  .join("、"); // 转换后的学生答题答案
              }
            }
          }
          // 获取作业详细数据
          data.row.examScore = 0; // 作业得分
          data.row.examCompletionDegree = 0; // 作业完成度
          data.row.examCorrectDegree = 0; // 作业正确率
          for (let i in res.data.ext.lesson_user) {
            let publicRes = res.data.ext.lesson_user[i];
            if (publicRes.link_resource_id == data.row.link_id && publicRes.user_id == this.currentStudentId && publicRes.link_exam_item_id != 0) {
              data.row.examCompletionDegree++; // 获取作业完成度
              data.row.examScore += publicRes.score; // 获取作业分数
              if (publicRes.score == publicRes.score_full) {
                data.row.examCorrectDegree++; // 获取作业正确率
              }
            }
          }
          this.dataResourceView = data.row; // 将整理好的数据渲染到页面
        });
      }
      // console.log(data.row);
    },
    // 试题切换按钮
    btnQuestion(type) {
      if (type == "previous") {
        if (this.currentTestQuestionIdx <= 0) {
          Toast("已经是第一题了！");
        } else {
          this.currentTestQuestionIdx--;
        }
      } else if (type == "next") {
        // console.log(this.currentTestQuestionIdx);
        if (this.currentTestQuestionIdx < this.dataResourceView.exam_items.length - 1) {
          this.currentTestQuestionIdx++;
        } else {
          Toast("已经是最后一题了！");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

/* 按学生查看部分 */
.studentView {
  height: calc(100% - 87px);
}

.classSelector {
  height: 100px;
}

.selector-txt {
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
  margin-right: 30px;
}

.studentList-content {
  width: 404px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.studentList-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 315px);
  overflow: scroll;
}

.student-ranking {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 40px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.selectStudents {
  display: flex;
  justify-content: space-between;
  width: 374px;
  background: #eaeaea;
  padding: 10px 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.unSelectStudents {
  display: flex;
  justify-content: space-between;
  width: 374px;
  background: #ffffff;
  padding: 10px 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.unSelectStudents:hover {
  background: #eaeaea;
}

.rankImg {
  width: 46px;
  height: 40px;
}

.head-sculpture {
  margin-left: 11px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.studentTxt {
  font-size: 16px;

  font-weight: 400;
  color: #555555;
}

.integral-num {
  font-size: 30px;

  font-weight: 400;
  color: #349afe;
}

.integral-txt {
  margin-top: 9px;
  font-size: 14px;

  font-weight: 400;
  color: #555555;
}

.classTimesList {
  width: 559px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.courseSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.courseSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.classTimesList-title-box {
  margin-bottom: 2px;
  background: rgba(52, 154, 254, 0.25);
  padding: 17px 20px;
  box-sizing: border-box;
}

.classTimesList-title {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.classList-box {
  height: calc(100vh - 400px);
  overflow: scroll;
}

.allClasses {
  background: #eaeaea;
  padding: 16px 31px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.classList-circle {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.classList-num {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList-name {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList {
  padding: 16px 31px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.classList:hover {
  background: #eaeaea;
}

.data-box {
  width: calc(100% - 964px);
}

.courseData-box {
  height: calc(100% - 60px);
  padding: 30px 0 0 60px;
  box-sizing: border-box;
}

.searchIcon {
  width: 25px;
  height: 25px;
}

.courseSearch-content {
  padding: 20px 30px;
  box-sizing: border-box;
}

.classTimesList-block {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.echartsPie-box {
  width: 318px;
  height: 251px;
}

.echartsPie-key {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
  line-height: 22px;
}

.echartsPie-value {
  margin-left: 20px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  line-height: 22px;
}

.classNumberData-box {
  height: calc(100% - 60px);
  padding: 16px;
  box-sizing: border-box;
}

.echarts-box {
  width: 220px;
}

.tableStyle {
  height: calc(100vh - 280px);
  box-sizing: border-box;
  overflow: scroll;
}

.tableWidth {
  width: 100%;
}

.resourceList-h1Box {
  padding-left: 20px;
  height: 60px;
  background: #cce6ff;
}

.resourceList-colorBlock {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.resourceList-h1 {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.resourceList-h2Box {
  padding-left: 30px;
  height: 50px;
  background: #eaeaea;
}

.resourceList-round {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.resourceList-h2 {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 22px;
}

.btnView {
  width: 22px;
  height: 22px;
}

// 查看资源弹窗
.popup-resourceView {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.resourceView-content {
  position: relative;
  width: 520px;
  height: 805px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  padding: 24px 30px;
  box-sizing: border-box;
}

.popup-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
}

.btnClose {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 23px;
  height: 23px;
}

.questionType-block {
  width: 8px;
  height: 18px;
  background: #3096fb;
}

.questionType {
  font-size: 18px;
  font-weight: normal;
  color: #000000;
  margin-left: 12px;
}

.question-score {
  font-size: 18px;
  font-weight: normal;
  color: #1f96fa;
}

.question-txt {
  margin-top: 14px;
  font-size: 18px;
  font-weight: normal;
  color: #1f96fa;
}

.question-stem {
  margin-top: 25px;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
  line-height: 25px;
}

.question-option {
  position: relative;
  margin-top: 16px;
  width: 454px;
  height: 48px;
  background: #1f96fa;
  border: 1px solid #1f96fa;
  border-radius: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #ffffff;
}

.question-option1 {
  position: relative;
  margin-top: 16px;
  width: 454px;
  height: 48px;
  background: #eeeeee;
  border: 1px solid #777777;
  border-radius: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
}

.answers-box {
  margin-top: 18px;
  width: 454px;
  height: 163px;
  border: 1px solid #777777;
  border-radius: 10px;
  padding: 16px 20px;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: normal;
  color: #777777;
  line-height: 24px;
}

.iconIsItCorrect {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 35px;
  height: 35px;
}

.resourcesDetails-frame {
  margin-top: 28px;
  width: 457px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-frame1 {
  width: 457px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #757575;
  border-radius: 10px;
}

.resourcesDetails-typeImg {
  width: 242px;
  height: 243px;
}

.resourcesDetails-detailsList {
  width: 653px;
  height: 280px;
}

.resourcesDetails-img {
  width: 457px;
  height: 256px;
  border-radius: 10px;
}

.dataResourceView-key {
  margin-top: 29px;
  font-size: 18px;

  font-weight: 400;
  color: #3096fb;
  line-height: 18px;
}

.dataResourceView-value {
  margin-top: 29px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.exam-key {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
  line-height: 18px;
}

.exam-value {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  line-height: 18px;
}

.exam-detailsContent {
  margin-top: 30px;
  height: 78px;
  border-bottom: 1px solid #bfbfbf;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.examitem-type {
  margin-top: 20px;
}

.examitem-box {
  height: 550px;
  overflow: auto;
}

.btnPreviousQuestion {
  width: 161px;
  height: 49px;
  background: #1f96fa;
  border-radius: 10px;
  font-size: 21px;
  font-weight: normal;
  color: #fefefe;
  line-height: 21px;
}

.btnNextQuestion {
  width: 161px;
  height: 49px;
  background: #1f96fa;
  border-radius: 10px;
  font-size: 21px;
  font-weight: normal;
  color: #fefefe;
  line-height: 21px;
}
</style>
